import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

import * as fromRulesModel from '@app/models/rules';


@Component({
    selector: 'settings-rules-rule-form-helper-search-results',
    templateUrl: './results.component.html',
    styleUrls: ['./results.component.scss','../rules-form-helpers-search-general.scss']
})
export class RulesHelpersSearchResultsComponent implements OnInit{

    @Input()  availableItems: Array<fromRulesModel.AvailableRuleActionVariableValueItem>;
    @Input()  selected: fromRulesModel.AvailableRuleActionVariableValueItem[];


    @Output() selectItem = new EventEmitter<fromRulesModel.AvailableRuleActionVariableValueItem>();


    ngOnInit(): void {

    }

    onSelect(item: fromRulesModel.AvailableRuleActionVariableValueItem) {
        if (this.isSelected(item.key))
            return;
        if(item?.options.selectable)
            this.selectItem.emit(item);
    }
    isSelected(key: string): boolean {
        return this.selected.map((sel) => sel.key).includes(key);
    }

}
